export function isBuffer(value) {
    return (value != null &&
        value.constructor != null &&
        typeof value.constructor.isBuffer === "function" &&
        value.constructor.isBuffer(value));
}
